import React from 'react';
import TaglineBar from '../FraudAlerts/components/TaglineBar';
import { AlertArticle } from '../FraudAlerts/FraudAlertDetailPage';
import { HotScamArticle } from '../HotScams/HotScamDetailPage';

// Full-page previews of unsaved content, rendered from the same article
// components the live pages use (FraudAlertDetailPage / HotScamDetailPage)
// so what an admin approves is what ships. The hub's tagline bar sits above
// the article as on the real page; the sub-tabs are drawn but inert.

const Modal = ({ heading, onClose, children, note }) => (
  <div
    className="fixed inset-0 z-50 bg-black/60 flex items-start justify-center overflow-y-auto p-6"
    onClick={onClose}
    role="presentation"
  >
    <div
      className="bg-white w-full max-w-5xl my-6 shadow-2xl"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between px-5 py-3 bg-[#1B5A8F] text-white sticky top-0 z-10">
        <p className="font-bold">{heading}</p>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close preview"
          className="w-8 h-8 flex items-center justify-center rounded-full text-2xl leading-none hover:bg-white/20"
        >
          &times;
        </button>
      </div>

      <div className="px-8 pt-6 pb-10">
        <TaglineBar />
        {children}
      </div>

      <p className="px-8 pb-6 text-xs text-gray-400">
        Preview only — nothing is saved or published from this view.{note ? ` ${note}` : ''}
      </p>
    </div>
  </div>
);

// `alert` is a row-shaped object (see alertPreviewShape in AlertPublisher):
// source, title, psa_number, published_at, source_url, summary, full_text,
// know_more.
export function AlertPreviewModal({ alert, onClose }) {
  return (
    <Modal heading="Preview — how readers will see this alert" onClose={onClose} note="The CyberFraud Alert / Av Library tabs open on the live page.">
      <AlertArticle alert={alert} />
    </Modal>
  );
}

// `scam` is a row-shaped object (see hotScamPreviewShape in AlertPublisher).
export function HotScamPreviewModal({ scam, onClose }) {
  return (
    <Modal heading="Preview — how readers will see this ScamWire page" onClose={onClose} note="The CyberFraud Alert / Av Library tabs open on the live page.">
      <HotScamArticle scam={scam} />
    </Modal>
  );
}
